import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs';

function Innovation() {
  const page = "innovation";
  return (
    <div>
      <section className={`hero ${page}`}>
        <h1>Innovation</h1>
      </section>

      <Breadcrumbs
          items={[
              { label: "Home", to: "/" },
              { label: "About", to: "/about" },
              { label: "Innovation" }, // no `to` = current page
      ]}
      />

      <section className="section section--white">
        <div className="fullscreen-kicker">
          <h3>Shaping the Future of Drilling Materials</h3>
        </div>
        <div className="container">
          <p>
            Innovation at <strong>DMCO</strong> is about pushing boundaries in material science, production efficiency, and customer-centric solutions. We invest in advanced manufacturing techniques 
            and digital tools to produce drilling materials that are stronger, safer, and more sustainable.
          </p>
        </div>
      </section>

      <section className="section section--grey">
        <div className="fullscreen-kicker">
          <h3>Innovation in Action</h3>
        </div>
        <div className="container">
          <p>
            For our customers, innovation translates into <strong>longer-lasting materials, improved drilling performance, and cost efficiency</strong>. By rethinking traditional approaches and embracing new technologies, 
            we create tangible advantages that directly impact operational success.
          </p>
        </div>
      </section>    

      <section className="section section--white">
        <div className="fullscreen-kicker">
          <h3>Sustainable Innovation</h3>
        </div>
        <div className="container">
          <p>
            We continuously explore new ways to optimize energy use, reduce waste, and lower environmental impact during production. Every innovation is designed with both performance and responsibility in mind, ensuring 
            our customers benefit from solutions that meet global expectations for sustainability.
          </p>
        </div>
      </section>

      <section className="section section--grey">
        <div className="fullscreen-kicker">
          <h3>From Ideas to Field-Proven Results</h3>
        </div>
        <div className="container">
          <p>
            At DMCO, innovation is measured by outcomes. Whether it’s developing more durable drilling materials, enhancing production processes, or enabling smarter systems, our innovations deliver measurable value 
            where it matters most—in the field, for our customers.
          </p>
        </div>
      </section>      
    </div>
  )
}

export default Innovation